var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.09457 13.466L4.05566 8.38793L37.625 8.38793L37.625 6.69523L4.05577 6.69522L9.09457 1.61731L7.90687 0.420409L0.84048 7.54163L7.90687 14.6629L9.09457 13.466Z","fill":"#0005FB"}));
}

ArrowLeft.defaultProps = {"width":"38","height":"15","viewBox":"0 0 38 15","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
